
import React, { useEffect, useState } from "react";
import { Editor } from "@tiptap/react";

interface EditorFooterProps {
  editor: Editor;
}

const EditorFooter = ({ editor }: EditorFooterProps) => {
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(0);
  
  // Use useEffect to update counts when the editor content changes
  useEffect(() => {
    if (editor) {
      // Safely access the character count extension
      const hasCharacterCount = editor.storage.characterCount !== undefined;
      
      if (hasCharacterCount) {
        setWordCount(editor.storage.characterCount.words());
        setCharCount(editor.storage.characterCount.characters());
        
        // Subscribe to editor content changes
        const updateStats = () => {
          setWordCount(editor.storage.characterCount.words());
          setCharCount(editor.storage.characterCount.characters());
        };
        
        editor.on('update', updateStats);
        
        return () => {
          editor.off('update', updateStats);
        };
      } else {
        // Fallback to estimate counts when the extension is not available
        const estimateCounts = () => {
          const text = editor.getText();
          // Simple word count estimation by splitting on whitespace
          const words = text ? text.trim().split(/\s+/).filter(Boolean).length : 0;
          const chars = text ? text.length : 0;
          
          setWordCount(words);
          setCharCount(chars);
        };
        
        estimateCounts();
        
        editor.on('update', estimateCounts);
        
        return () => {
          editor.off('update', estimateCounts);
        };
      }
    }
  }, [editor]);

  return (
    <div className="flex justify-between items-center p-2 border-t text-xs text-muted-foreground">
      <div>
        {wordCount} words
        &nbsp;•&nbsp;
        {charCount} characters
      </div>
    </div>
  );
};

export default EditorFooter;
